const _SignatureStatusCodes = {
  CANCELLED: 'SignatureRequiredCancelledByCardholder',
  NOT_REQUIRED: 'SignatureNotRequiredByPaymentType',
  REQUIRED_NOT_SUPPORTED_BY_PIN_PAD: 'SignatureRequiredNotSupportedByPinPad',
  UNKNOWN: 'Unknown',
};

export default class SignatureStatusCodes {
  static get Codes() {
    return _SignatureStatusCodes;
  }
}
